import SsoSettings from "./components/SsoSettings";

export const routes = [
  {
    path: "/ssoSettings",
    exact: true,
    component: SsoSettings,
    name: "ssoSettings"
  }
];
